import React, { useCallback, useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import PaymentsService from '../../services/payments.service'
import { getAccountListSelector, getMenuListSelector } from '../../store/selectors/app.selector'
import BankToWalletIcon from "custom/assets/quickTransfer/BankWallet.svg"
import QuickTransfer_InstantTransferIcon from 'custom/assets/quickTransfer/InstantTransfer.svg'
import { QUICK_PAY_MENU_KEYS } from '../../utils/translation-constants'
import LayoutWithAccountCard from '../Layout/layout-account-card'


const ICONS = {
  BANKTOWALLET: BankToWalletIcon
}

export default function QuickPay() {
  const history = useHistory()
  const accounts = useSelector(getAccountListSelector) || []
  const { t } = useTranslation()
  const [billerList, setBillerList] = useState([])
  const location = useLocation()
  const [data, setData] = useState({url:"",breadCrumb:""})

  useEffect(() => {
    location.pathname.includes('/transfers')&&setData({url:'/transfers',breadCrumb:'TRANSFERS_QUICK_PAY'})
    location.pathname.includes('/accounts') && setData({url:'/accounts',breadCrumb:'ACCOUNTS_QUICK_PAY'})
    getBillProducts()
  }, [])

  const getBillProducts = useCallback(async () => {
    try {
      const response = await PaymentsService.getAllBillers({
        fetchServices: false,
        fetchProducts: false,
        module: 'TRANSFER',
      })
      if (response.status === 200) {
        response.data['categories'].forEach((element) => {
          element.title = element.category
          element.icon = ICONS[element.category]
          element.key = element.category
        })
        setBillerList(response.data['categories'])
      }
    } catch (err) {
      console.log(err)
    }
  }, [])

  return (
    <LayoutWithAccountCard breadCumKey={data.breadCrumb}>
      <Row>
        <Col
          xs={'auto'}
          sm={'auto'}
          md={'auto'}
          className='account-menu-card'
          onClick={() => (accounts.length > 0 ? history.push(`${data.url}/quick-pay/instant-transfer`): '')}>
          <img width={46} height={40} src={QuickTransfer_InstantTransferIcon} />
          <h2>{t(QUICK_PAY_MENU_KEYS.INSTANT_TRANSFER)}</h2>
          <span>{t(QUICK_PAY_MENU_KEYS.INSTANT_TRANSFER_DESCRIPTION)}</span>
        </Col>
        {billerList.map((option, index) => (
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            key={index}
            className='account-menu-card'
            onClick={() => history.push({
              pathname: `${data.url}/quick-pay/servicesView`,
              state: { categoryDetails: option },
            })}>
            <img width={52} height={40} src={option.icon} />
            <h2>{t(option.title)}</h2>
            <span>{t(option.desc)}</span>
          </Col>
        ))}
      </Row>
    </LayoutWithAccountCard>
  )
}
